// src/js/components/App.js
import React from "react";
import Evaluation from "./Evaluation";
// import Capabilities from "./Capabilities/Capabilities"
// import CalendlyWidget from "./calendly/CalendlyWidget";

const App = () => (
    <>
        <Evaluation />
        {/*<Capabilities />*/}
        {/*<CalendlyWidget display={true} />*/}
    </>
);

export default App;